import Cookie from 'cookie'
import getToken from './getToken'
const reqOption = () => {
  let options = {
    headers: {},
  }

  const token = getToken()
  if (token) {
    options.headers['x-auth-token'] = token
    return options
  }
}

export default reqOption
